export var EField;
(function (EField) {
    EField["Firstname"] = "firstname";
    EField["Lastname"] = "lastname";
    EField["Email"] = "email";
    EField["Phone"] = "phone";
    EField["Password"] = "password";
    EField["Captcha"] = "captcha";
})(EField || (EField = {}));
